'use client';

import { useScrollTracking } from '@/hooks/useScrollTracking';

/**
 * Client-side wrapper component that adds scroll tracking
 */
export default function ScrollTracker({ children }: { children: React.ReactNode }) {
  useScrollTracking();
  return <>{children}</>;
}
